import { Component } from '@angular/core';

@Component({
  selector: 'app-forgotten-password-success',
  imports: [],
  templateUrl: './forgotten-password-success.component.html',
  styleUrl: './forgotten-password-success.component.scss'
})
export class ForgottenPasswordSuccessComponent {

}
